/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_FinishInputs */



/**
* | output |
* | --- |
* | "Finish recording" |
*
* @param {Meeting_Offline_FinishInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_finish = /** @type {((inputs?: Meeting_Offline_FinishInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_FinishInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Opname afsluiten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminer l'enregistrement")
	return /** @type {LocalizedString} */ ("Finish recording")
});